<template>
<div class="reg-application-form-fields">
                <div class="regJob-dom">
                    <div class="regJob-form-t">最高学历 <span class="red">*</span></div>
                    <div class="regJob-form-b">
                        <el-select v-model="bmObj.highestEducation" placeholder="请选择最高学历" style="width: 100%;">
                            <el-option v-for="(item,index) in highestEducationList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </div>
                <template v-if="educationRecords.length > 0">
                    <div class="regJob-dom edu-section" v-for="(edu, eduIndex) in educationRecords" :key="edu.label + '-' + eduIndex">
                        <div class="regJob-tle">{{ edu.label }}</div>
                        <div class="regJob-b regJob-b--domestic-top">
                            <el-row :gutter="16">
                                <el-col :span="24" v-if="shouldShowDomesticField(edu)">
                                    <div class="regJob-form-t">{{ getDomesticFieldLabel(edu) }} <span class="red">*</span></div>
                                    <div class="regJob-form-b">
                                        <el-radio-group v-model="edu.isDomestic" @change="onEduDomesticChange(edu)">
                                            <el-radio :label="1">是</el-radio>
                                            <el-radio :label="0">否</el-radio>
                                        </el-radio-group>
                                    </div>
                                </el-col>
                                <el-col :span="24" v-if="shouldShowQsRankingField(edu)">
                                    <div class="regJob-form-t">院校2025QS排名 <span class="red">*</span></div>
                                    <div class="regJob-form-b">
                                        <el-input-number v-model="edu.qsRanking" :min="1" :max="9999" :controls="true" placeholder="请输入QS排名" style="width: 100%;"></el-input-number>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                        <div v-if="shouldShowXuexinUpload(eduIndex)" class="dragDom" @dragover.prevent @drop.prevent="upXjzTz($event, eduIndex)">
                            <div class="dragDom-t1">{{ getXuexinUploadTitle(eduIndex) }}</div>
                            <div class="dragDom-t2">
                                <div class="uploadBtn-dom">
                                    <input :id="'xjz-' + eduIndex" type="file" class="uploadBtn-input" @input="upXjz($event, eduIndex)" accept="application/pdf" />
                                    <button class="uploadBtn">选择证书</button>
                                </div>
                            </div>
                            <div class="dragDom-t3">{{ getXuexinUploadHint(eduIndex) }}</div>
                            <div v-if="isXuexinOcrEnabled(eduIndex)" class="dragDom-t3" style="color: #E7000B; margin-top: 8px;">提示：必须是从学信网下载的PDF电子版文件，否则可能会识别错误</div>
                            <div class="dragDom-file" v-if="edu.file && edu.file.url">
                                <a class="fileShow" :href="edu.file.url" target="_blank">{{ edu.file.fileName || '' }}</a>
                                <a class="fileDel" href="javascript:;" @click="delEduFile(eduIndex)">删除</a>
                            </div>
                        </div>
                        <div class="regJob-b">
                            <el-row :gutter="16">
                                <el-col :span="24">
                                    <div class="regJob-form-t">学校 <span class="red">*</span></div>
                                    <div class="regJob-form-b">
                                        <el-input placeholder="" v-model="edu.graduatedInstitution" :disabled="edu.prefilledReadonly.graduatedInstitution"></el-input>
                                    </div>
                                </el-col>
                                <template v-if="isTechUndergradEduSection(edu)">
                                    <el-col :span="8">
                                        <div class="regJob-form-t">学科/专业 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-input placeholder="" v-model="edu.major" :disabled="edu.prefilledReadonly.major"></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="regJob-form-t">专业代码 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-input placeholder="请输入专业代码" v-model="edu.majorCode" maxlength="64"></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="regJob-form-t">毕业日期 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-date-picker
                                                v-model="edu.departureDate"
                                                type="year"
                                                placeholder="选择毕业年份"
                                                style="width: 100%;"
                                                format="yyyy"
                                                value-format="yyyy-MM-dd"
                                                :disabled="edu.prefilledReadonly.departureDate"
                                            ></el-date-picker>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" v-if="isDomesticInstitution(edu)">
                                        <div class="regJob-form-t">院校层级 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-select v-model="edu.institutionType" placeholder="请选择院校层级" style="width: 100%;">
                                                <el-option v-for="item in institutionLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="regJob-form-t">学历 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-input placeholder="" v-model="edu.education" :disabled="edu.prefilledReadonly.education"></el-input>
                                        </div>
                                    </el-col>
                                </template>
                                <template v-else>
                                    <el-col :span="12">
                                        <div class="regJob-form-t">学科/专业 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-input placeholder="" v-model="edu.major" :disabled="edu.prefilledReadonly.major"></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="regJob-form-t">学历 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-input placeholder="" v-model="edu.education" :disabled="edu.prefilledReadonly.education"></el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="regJob-form-t">毕业日期 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-date-picker
                                                v-model="edu.departureDate"
                                                type="year"
                                                placeholder="选择毕业年份"
                                                style="width: 100%;"
                                                format="yyyy"
                                                value-format="yyyy-MM-dd"
                                                :disabled="edu.prefilledReadonly.departureDate"
                                            ></el-date-picker>
                                        </div>
                                    </el-col>
                                    <el-col :span="12" v-if="isDomesticInstitution(edu)">
                                        <div class="regJob-form-t">院校层级 <span class="red">*</span></div>
                                        <div class="regJob-form-b">
                                            <el-select v-model="edu.institutionType" placeholder="请选择院校层级" style="width: 100%;">
                                                <el-option v-for="item in institutionLevelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                </template>
                            </el-row>
                        </div>
                        <div class="edu-cert-block" v-if="shouldShowGradDegreeCerts(edu) || isOverseasInstitution(edu)">
                            <el-row :gutter="16">
                                <el-col :span="12" v-if="shouldShowGradDegreeCerts(edu)">
                                    <div class="dragDom edu-cert-drag" @dragover.prevent @drop.prevent="upEduGradCertTz($event, eduIndex)">
                                        <div class="dragDom-t1">{{ edu.label }} - 毕业证</div>
                                        <div class="dragDom-t2">
                                            <div class="uploadBtn-dom">
                                                <input :id="'grad-' + eduIndex" type="file" class="uploadBtn-input" @change="upEduGradCert($event, eduIndex)" :accept="certFileAccept" />
                                                <button class="uploadBtn">选择证书</button>
                                            </div>
                                        </div>
                                        <div class="dragDom-t3">每个学历段限上传 1 个，支持 PDF 或图片格式，文件大小 6M 以内</div>
                                        <div class="dragDom-file" v-if="edu.graduationCert && edu.graduationCert.url">
                                            <a class="fileShow" :href="edu.graduationCert.url" target="_blank">{{ edu.graduationCert.fileName || '' }}</a>
                                            <a class="fileDel" href="javascript:;" @click="delEduGradCert(eduIndex)">删除</a>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="12" v-if="shouldShowGradDegreeCerts(edu)">
                                    <div class="dragDom edu-cert-drag" @dragover.prevent @drop.prevent="upEduDegCertTz($event, eduIndex)">
                                        <div class="dragDom-t1">{{ edu.label }} - 学位证</div>
                                        <div class="dragDom-t2">
                                            <div class="uploadBtn-dom">
                                                <input :id="'degree-' + eduIndex" type="file" class="uploadBtn-input" @change="upEduDegCert($event, eduIndex)" :accept="certFileAccept" />
                                                <button class="uploadBtn">选择证书</button>
                                            </div>
                                        </div>
                                        <div class="dragDom-t3">每个学历段限上传 1 个，支持 PDF 或图片格式，文件大小 6M 以内</div>
                                        <div class="dragDom-file" v-if="edu.degreeCert && edu.degreeCert.url">
                                            <a class="fileShow" :href="edu.degreeCert.url" target="_blank">{{ edu.degreeCert.fileName || '' }}</a>
                                            <a class="fileDel" href="javascript:;" @click="delEduDegCert(eduIndex)">删除</a>
                                        </div>
                                    </div>
                                </el-col>
                                <el-col :span="isOverseasInstitution(edu) ? 24 : 12" v-if="isOverseasInstitution(edu)">
                                    <div class="dragDom edu-cert-drag" @dragover.prevent @drop.prevent="upEduStudyAbroadCertTz($event, eduIndex)">
                                        <div class="dragDom-t1">教育部留学服务中心认证</div>
                                        <div class="dragDom-t2">
                                            <div class="uploadBtn-dom">
                                                <input :id="'study-abroad-' + eduIndex" type="file" class="uploadBtn-input" @change="upEduStudyAbroadCert($event, eduIndex)" :accept="certFileAccept" />
                                                <button class="uploadBtn">选择证书</button>
                                            </div>
                                        </div>
                                        <div class="dragDom-t3">留学回国人员须上传，限 1 个，支持 PDF 或图片，文件大小 6M 以内</div>
                                        <div class="dragDom-file" v-if="edu.studyAbroadCert && edu.studyAbroadCert.url">
                                            <a class="fileShow" :href="edu.studyAbroadCert.url" target="_blank">{{ edu.studyAbroadCert.fileName || '' }}</a>
                                            <a class="fileDel" href="javascript:;" @click="delEduStudyAbroadCert(eduIndex)">删除</a>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </template>
                <div class="regJob-dom">
                    <div class="regJob-tle">联系信息</div>
                    <div class="regJob-b">
                        <el-row :gutter="16">
                            <el-col :span="10">
                                <div class="dragDom" @dragover.prevent @drop.prevent="upIdCardTz">
                                    <div class="dragDomP">
                                        <img v-if="files.f1 && files.f1.url" :src="(files.f1 && files.f1.url) ? files.f1.url : ''" />
                                    </div>
                                    <div class="dragDom-t1">身份证人像面</div>
                                    <div class="dragDom-t2">
                                        <div class="uploadBtn-dom">
                                            <input type="file" class="uploadBtn-input" @change = "upIdCard" accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif" />
                                            <button class="uploadBtn">上传</button>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="10">
                                <div class="dragDom" @dragover.prevent @drop.prevent="upIdCard2Tz">
                                    <div class="dragDomP">
                                        <img v-if="files.f2 && files.f2.url" :src="(files.f2 && files.f2.url) ? files.f2.url : ''" />
                                    </div>
                                    <div class="dragDom-t1">身份证国徽面</div>
                                    <div class="dragDom-t2">
                                        <div class="uploadBtn-dom">
                                            <input type="file" class="uploadBtn-input" @change = "upIdCard2" accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif" />
                                            <button class="uploadBtn">上传</button>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="dragDom" @dragover.prevent @drop.prevent="upPhotoTz">
                                    <div class="dragDomP">
                                        <img v-if="files.f3 && files.f3.url" :src="(files.f3 && files.f3.url) ? files.f3.url : ''" />
                                    </div>
                                    <div class="dragDom-t1">免冠照</div>
                                    <div class="dragDom-t2">
                                        <div class="uploadBtn-dom">
                                            <input type="file" class="uploadBtn-input" @change = "upPhoto" accept="image/png, image/jpeg, image/jpg, image/bmp, image/gif" />
                                            <button class="uploadBtn">上传</button>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">姓名 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="bmObj.name"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">性别 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-select
                                        v-model="bmObj.gender"
                                        placeholder="请选择"
                                        style="width: 100%;"
                                        @change="markGenderTouched">
                                        <el-option label="男" :value="1"></el-option>
                                        <el-option label="女" :value="0"></el-option>
                                        <el-option label="其他" :value="2"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">出生年月 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-date-picker
                                        v-model="bmObj.birthDate"
                                        type="date"
                                        placeholder="选择出生年月"
                                        style="width: 100%;"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        :append-to-body="true"
                                    ></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">身份证号 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="bmObj.idCardNumber"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">政治面貌 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-select
                                        v-model="bmObj.politicalStatus"
                                        placeholder="请选择政治面貌"
                                        clearable
                                        style="width: 100%;">
                                        <el-option v-for="(item,index) in politicalStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </div>
                            </el-col>
<!--                            <el-col :span="8">
                                <div class="regJob-form-t">当前居住国家/地区 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-select v-model="bmObj.residentCountryRegion" placeholder="当前居住国家/地区" style="width: 100%;">
                                        <el-option
                                            v-for="item in country"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>-->
<!--                            <el-col :span="8">
                                <div class="regJob-form-t">当前居住省/市 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-select v-model="bmObj.residentProvinceCity" placeholder="当前居住省/市" style="width: 100%;">
                                        <el-option
                                            v-for="item in citys"
                                            :key="item.code"
                                            :label="item.name"
                                            :value="item.name">
                                        </el-option>
                                    </el-select>
                                </div>
                            </el-col>-->
                            <el-col :span="8">
                                <div class="regJob-form-t">籍贯 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-select v-model="bmObj.residentProvinceCity" placeholder="请选择省份" style="width: 100%;" @change="handleProvinceChange">
                                                <el-option
                                                        v-for="item in citys"
                                                        :key="item.code"
                                                        :label="item.name"
                                                        :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-select v-model="bmObj.residentCity" placeholder="请选择城市" style="width: 100%;" :disabled="!bmObj.residentProvinceCity" @change="syncNativePlaceFromDropdown">
                                                <el-option
                                                        v-for="item in currentCities"
                                                        :key="item.code"
                                                        :label="item.name"
                                                        :value="item.name">
                                                </el-option>
                                            </el-select>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-col>

                            <el-col :span="12">
                                <div class="regJob-form-t">常住地址 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="身份证OCR识别后可编辑" v-model="bmObj.address"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="regJob-form-t">手机号 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="bmObj.phone"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="regJob-form-t">电子邮箱 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="bmObj.email"></el-input>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
<!--                <div class="regJob-dom">
                    <div class="regJob-tle">工作经历</div>
                    <div class="regJob-b1" v-for="(item,index) in work" :key="index">
                        <i v-if="index>0" class="el-icon-circle-close listClose" @click="delWorkli(index)"></i>
                        <el-row :gutter="16">
                            <el-col :span="12">
                                <div class="regJob-form-t">工作职责 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="item.jobDuties"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="regJob-form-t">公司名称 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="item.companyName"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">开始时间 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-date-picker v-model="item.startDate" type="month" placeholder="选择月" style="width: 100%;"></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span="8" v-if="!item.now">
                                <div class="regJob-form-t">结束时间 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-date-picker v-model="item.endDate" type="month" placeholder="选择月" style="width: 100%;"></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">结束时间 <span class="red">*</span></div>
                                <div class="regJob-form-b" style="padding-top: 10px;">
                                    <el-checkbox v-model="item.now" @change="checkEnd(index)">工作至今</el-checkbox>
                                </div>
                            </el-col>
                            <el-col :span="24">
                                <div class="regJob-form-t">工作描述 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6}" placeholder="请输入" v-model="item.jobDescription"></el-input>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="addDom" @click="workAdd"> <i class="el-icon-plus"></i> 添加更多工作经历</div>
                </div>-->
                <div class="regJob-dom">
                    <div class="regJob-tle">家庭成员</div>
                    <div class="regJob-b1" v-for="(item,index) in family" :key="index">
                        <el-row :gutter="16">
                            <el-col :span="6">
                                <div class="regJob-form-t">与本人关系 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input :value="relationType[item.relationType]" disabled></el-input>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="regJob-form-t">姓名 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="family[index].name"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="regJob-form-t">手机号 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="family[index].mobile"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="regJob-form-t">工作单位 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="family[index].workUnit"></el-input>
                                </div>
                            </el-col>
<!--                            <el-col :span="8">
                                <div class="regJob-form-t">职务 <span class="red">*</span></div>
                                <div class="regJob-form-b">
                                    <el-input placeholder="" v-model="family[index].position"></el-input>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">出生日期</div>
                                <div class="regJob-form-b">
                                    <el-date-picker v-model="family[index].birthDate" type="date" placeholder="选择日期" style="width: 100%;"></el-date-picker>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="regJob-form-t">潞安化工职工</div>
                                <div class="regJob-form-b">
                                    <el-select v-model="isInLuan[family[index].isInLuan]" placeholder="请选择" style="width: 100%;">
                                        <el-option label="否" value="0"></el-option>
                                        <el-option label="是" value="1"></el-option>
                                    </el-select>
                                </div>
                            </el-col>-->
                        </el-row>
                    </div>
                </div>
                <div class="regJob-dom">
                    <div class="regJob-tle">无犯罪记录证明</div>
                    <div class="regJob-b">
                        <div class="dragDom" @dragover.prevent @drop.prevent="upCriminalRecordTz">
                            <div class="dragDom-t1">3个月内开具的无犯罪记录证明</div>
                            <div class="dragDom-t2">
                                <div class="uploadBtn-dom">
                                    <input id="criminal-record" type="file" class="uploadBtn-input" @change="upCriminalRecord" :accept="certFileAccept" />
                                    <button class="uploadBtn">选择文件</button>
                                </div>
                            </div>
                            <div class="dragDom-t3">限上传 1 个，支持 PDF 或图片格式，文件大小 6M 以内</div>
                            <div class="dragDom-file" v-if="files.f9 && files.f9.url">
                                <a class="fileShow" :href="files.f9.url" target="_blank">{{ files.f9.fileName || '' }}</a>
                                <a class="fileDel" href="javascript:;" @click="delCriminalRecord">删除</a>
                            </div>
                        </div>
                    </div>
                </div>
</div>
</template>

<script>
const REG_FORM_METHODS = [
  'getXuexinUploadTitle',
  'getXuexinUploadHint',
  'isXuexinOcrEnabled',
  'isTechUndergradEduSection',
  'shouldShowDomesticField',
  'shouldShowQsRankingField',
  'isDomesticInstitution',
  'isOverseasInstitution',
  'getDomesticFieldLabel',
  'shouldShowXuexinUpload',
  'shouldShowGradDegreeCerts',
  'upXjzTz',
  'upXjz',
  'delEduFile',
  'onEduDomesticChange',
  'upEduGradCertTz',
  'upEduGradCert',
  'delEduGradCert',
  'upEduDegCertTz',
  'upEduDegCert',
  'delEduDegCert',
  'upEduStudyAbroadCertTz',
  'upEduStudyAbroadCert',
  'delEduStudyAbroadCert',
  'upIdCardTz',
  'upIdCard',
  'upIdCard2Tz',
  'upIdCard2',
  'upPhotoTz',
  'upPhoto',
  'handleProvinceChange',
  'syncNativePlaceFromDropdown',
  'upCriminalRecordTz',
  'upCriminalRecord',
  'delCriminalRecord',
];

export default {
  name: 'RegApplicationFormFields',
  inject: ['regLink'],
  computed: {
    bmObj() { return this.regLink.bmObj; },
    files() { return this.regLink.files; },
    educationRecords() { return this.regLink.educationRecords; },
    family() { return this.regLink.family; },
    citys() { return this.regLink.citys; },
    currentCities() { return this.regLink.currentCities; },
    highestEducationList() { return this.regLink.highestEducationList; },
    politicalStatusList() { return this.regLink.politicalStatusList; },
    institutionLevelList() { return this.regLink.institutionLevelList; },
    relationType() { return this.regLink.relationType; },
    sex() { return this.regLink.sex; },
    certFileAccept() { return this.regLink.certFileAccept; },
  },
  created() {
    REG_FORM_METHODS.forEach((name) => {
      this[name] = (...args) => this.regLink[name](...args);
    });
  },
  methods: {
    markGenderTouched() {
      if (this.regLink && typeof this.regLink.markGenderTouched === 'function') {
        this.regLink.markGenderTouched();
      }
    },
  },
};
</script>

<style scoped>
.reg-application-form-fields {
  width: 100%;
  box-sizing: border-box;
}
</style>

<style>
.reg-application-form-fields .regJob-dom {
  padding: 0 4px 16px;
  box-sizing: border-box;
}
.reg-application-form-fields .edu-section {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #F3F4F6;
}
.reg-application-form-fields .edu-section:last-of-type {
  border-bottom: none;
}
.reg-application-form-fields .regJob-b--domestic-top {
  padding-bottom: 4px;
}
.reg-application-form-fields .regJob-tle {
  line-height: 28px;
  font-size: 17px;
  font-weight: 700;
  color: #101828;
  padding: 8px 0 12px;
  border-left: 3px solid #E7000B;
  padding-left: 10px;
}
.reg-application-form-fields .regJob-b {
  padding-top: 12px;
  border-top: 1px solid #E5E7EB;
}
.reg-application-form-fields .regJob-b1 {
  padding: 14px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  position: relative;
  margin-bottom: 10px;
  background: #FAFAFA;
}
.reg-application-form-fields .regJob-form-t {
  font-size: 13px;
  line-height: 20px;
  color: #364153;
  margin-bottom: 4px;
}
.reg-application-form-fields .regJob-form-b {
  padding-bottom: 12px;
}
.reg-application-form-fields .red {
  color: #E7000B;
}
.reg-application-form-fields .dragDom {
  padding: 16px 12px;
  border: 2px dashed #D1D5DC;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 12px;
  position: relative;
  background: #FAFAFA;
  box-sizing: border-box;
}
.reg-application-form-fields .dragDomP {
  width: 100%;
  min-height: 80px;
  margin-bottom: 8px;
  position: relative;
}
.reg-application-form-fields .dragDomP img {
  max-width: 100%;
  max-height: 120px;
  object-fit: contain;
}
.reg-application-form-fields .dragDom-t1 {
  color: #323232;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 4px;
}
.reg-application-form-fields .edu-cert-drag .dragDom-t1 {
  font-size: 14px;
}
.reg-application-form-fields .dragDom-t2 {
  padding: 10px 0;
  text-align: center;
}
.reg-application-form-fields .dragDom-t3 {
  font-size: 12px;
  color: #6A7282;
  text-align: center;
  line-height: 18px;
  margin-top: 6px;
  position: static;
  width: auto;
  height: auto;
}
.reg-application-form-fields .uploadBtn-dom {
  width: 130px;
  height: 40px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.reg-application-form-fields .uploadBtn-dom input {
  width: 600px;
  height: 200px;
  font-size: 200px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
}
.reg-application-form-fields .uploadBtn {
  width: 130px;
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
  border: 1px solid #FF1616;
  background: #E60012;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.reg-application-form-fields .uploadBtn:hover {
  background-color: #C10007;
}
.reg-application-form-fields .dragDom-file {
  text-align: left;
  padding: 10px 12px 0;
  word-break: break-all;
}
.reg-application-form-fields .fileShow {
  color: #155DFC;
  text-decoration: none;
  font-size: 13px;
}
.reg-application-form-fields .fileDel {
  margin-left: 12px;
  color: #E7000B;
  font-size: 13px;
  cursor: pointer;
}
.reg-application-form-fields .edu-cert-block {
  margin-top: 12px;
}
.reg-application-form-fields .form-fjli {
  line-height: 22px;
  padding: 8px 12px;
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  background: #F9FAFB;
  margin-bottom: 8px;
}
.reg-application-form-fields .form-fjli-l {
  float: left;
  line-height: 22px;
  color: #333;
  font-size: 13px;
  max-width: calc(100% - 40px);
  word-break: break-all;
}
.reg-application-form-fields .form-fjli-r {
  float: right;
  line-height: 22px;
  color: #E7000B;
  font-size: 16px;
  cursor: pointer;
}
.reg-application-form-fields .form-fjli::after {
  content: "";
  display: block;
  clear: both;
}
.reg-application-form-fields .el-radio .el-radio__label {
  white-space: normal !important;
  word-break: break-word !important;
  line-height: 1.5;
}
</style>
